import { BackArrowIcon } from "@/assets/icons/admin";
import CustomDropdown from "@/components/admin/customdropdown";
import { ArrayItems } from "@/components/admin/customdropdown/dropdownarray";
import {
  useGetAllRoles,
  useGetAllUsers,
  useUpdateUser,
} from "@/services/admin.service";
import { AdminRegistration, AdminUser } from "@/types";
import { Button, Input } from "@nextui-org/react";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

interface EditAccTabProps {
  itemData: Partial<AdminUser>;
  onCancel: () => void;
}

const EditAccTab: React.FC<EditAccTabProps> = ({ itemData, onCancel }) => {
  const [isActiveEnabled, setIsActiveEnabled] = useState(
    itemData.status === "ACTIVE",
  );

  const [selectedRole, setSelectedRole] = useState<string | null>("all");

  const [username, setUsername] = useState(itemData.userName);
  const [isUsernameValid, setIsUsernameValid] = useState(true);
  const [email, setEmail] = useState(itemData.email);
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [role, setRole] = useState<ArrayItems>();
  const [fullName, setFullName] = useState(itemData.fullName);

  const { refetch } = useGetAllUsers({ page: 1, pageSize: 10 });
  const updateUser = useUpdateUser();
  const { data: getAllRoles, refetch: refetchRole } = useGetAllRoles({
    page: 1,
    pageSize: 10,
  });
  const accounts = getAllRoles?.data?.data.map((item: any) => ({
    label: item.name,
    value: item.id,
  }));

  const handleInputChange = (event: any) => {
    const { name, value } = event.target;
    if (name === "username") {
      setUsername(value);
      setIsUsernameValid(true);
    } else if (name === "email") {
      setEmail(value);
      setIsEmailValid(true);
    } else if (name === "fullname") {
      setFullName(value);
    }
  };

  const handleSave = () => {
    const isEmailValid = /\S+@\S+\.\S+/.test(email!);
    setIsEmailValid(isEmailValid);
    const updateData: Partial<AdminRegistration> = {
      email: email,
      fullName: fullName,
      status: isActiveEnabled ? "ACTIVE" : "IN_ACTIVE",
      roleId:
        role?.value.toString() ??
        accounts?.filter((value: any) => itemData.roleId === value.value)[0]
          .value,
    };

    if (username !== itemData.userName) {
      updateData.userName = username;
    }

    updateUser.mutate(
      { id: itemData.id!, data: updateData },
      {
        onSuccess: () => {
          console.log("Successfully updated user");
          toast.success("Successfully updated user");
          setTimeout(() => {
            onCancel();
          }, 1000);
        },
        onError: (err) => {
          console.error("Error updating user:", err);
          toast.error("Error updating user");
        },
      },
    );
  };

  const handleDropdownSelect = (selectedOption: ArrayItems | null) => {
    console.log("Selected option:", selectedOption);
    if (selectedOption !== null) {
      setRole(selectedOption);
      setSelectedRole(selectedOption.value);
    }
  };

  useEffect(() => {
    refetch();
    refetchRole();
  }, [refetch, refetchRole]);

  return (
    <div>
      <div className="font-ubuntu mb-3 w-full text-center text-2xl font-semibold text-white sm:float-left sm:mb-3">
        <span>
          <Button
            isIconOnly
            onClick={onCancel}
            className="transparent-bg float-left ml-[-11px] h-auto w-auto"
          >
            <BackArrowIcon />
          </Button>
          <p className="text-sm sm:float-left sm:text-lg md:text-lg lg:text-lg">
            Edit Account
          </p>
        </span>
      </div>
      <div className="w-full">
        <div className="flex w-full flex-col ">
          <label
            htmlFor="firstName"
            className="field-label mb-2 block text-sm font-normal text-white"
          >
            Username
          </label>
          <div></div>
          <Input
            name="username"
            value={username}
            onChange={handleInputChange}
            className={`w-full rounded-md border border-solid ${isUsernameValid ? "input-bg" : "validation"} !cursor-text`}
            classNames={{
              inputWrapper: ["!cursor-text", "bg-white-5", "text-sm"],
            }}
          ></Input>
          {!isUsernameValid && (
            <p className="validation-txt mt-1 text-sm">
              *Username already used. Try Another one.
            </p>
          )}
        </div>
        <div className="mt-3 flex w-full flex-col">
          <label
            htmlFor="firstName"
            className="field-label mb-2 block text-sm font-normal text-white"
          >
            Fullname
          </label>
          <Input
            onChange={handleInputChange}
            name="fullname"
            value={fullName}
            className="input-bg w-full"
            classNames={{
              inputWrapper: ["!cursor-text", "bg-white-5", "text-sm"],
            }}
          ></Input>
        </div>
        <div className="mt-3 flex w-full flex-col">
          <label
            htmlFor="firstName"
            className="field-label mb-2 block text-sm font-normal text-white"
          >
            Email
          </label>
          <Input
            disabled={true}
            name="email"
            value={email}
            onChange={handleInputChange}
            className={`w-full rounded-md border border-solid ${isEmailValid ? "input-bg" : "validation"} !cursor-text`}
            classNames={{
              inputWrapper: ["!cursor-text", "bg-white-5", "text-sm"],
            }}
          ></Input>
          {!isEmailValid && (
            <p className="validation-txt mt-1 text-sm">
              *Email is invalid. Try another email
            </p>
          )}
        </div>
        <div className="mt-3 flex w-full flex-col">
          <label
            htmlFor="firstName"
            className="field-label mb-2 block text-sm font-normal text-white"
          >
            Group Privilege
          </label>
          <div className="w-full">
            <CustomDropdown
              options={accounts}
              onSelect={handleDropdownSelect}
              placeholder={
                accounts?.filter(
                  (value: any) => itemData.roleId === value.value,
                )[0].label
              }
              dropdownHeight="100px"
              value={selectedRole ?? ""}
            />
          </div>
        </div>
      </div>
      <div className="flex w-full flex-col gap-6">
        <div className="sm:flex sm:flex-row">
          <div className="mt-1 flex basis-full items-center sm:mt-[-15px] sm:basis-1/2">
            <div>
              <h2 className="text-base font-bold text-white">
                INACTIVE / ACTIVE
              </h2>
            </div>
            <div>
              <label
                htmlFor="activestate"
                className="field-label relative ml-[161px] mt-2 inline-flex cursor-pointer items-center sm:ml-5 sm:mt-1"
              >
                <input
                  type="checkbox"
                  id="activestate"
                  className="peer sr-only"
                  checked={isActiveEnabled}
                  onClick={() => {
                    setIsActiveEnabled(!isActiveEnabled);
                  }}
                />
                <div className="peer h-6 w-11 rounded-full bg-gray-600 transition after:absolute after:left-[2px] after:top-0.5 after:h-5 after:w-5 after:rounded-full after:border after:border-gray-300 after:bg-white/50 after:transition-transform after:content-[''] peer-checked:bg-[#50FF13] peer-checked:after:translate-x-full"></div>
              </label>
            </div>
          </div>
          <div className="mb-10 mt-5 w-fit basis-full sm:basis-1/2">
            <div className="float-right">
              <Button
                onClick={handleSave}
                className="admin-common-button-gradient font-ubuntu w-full rounded-md pl-32 pr-32 text-base font-bold sm:pl-20 sm:pr-20"
              >
                <span className="">Save Changes</span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditAccTab;
